import { ApiRequest } from "../../services/api"

export const EnableUser = async (userId) => {
    return await ApiRequest('PUT', "admin/v2/enable-user?userId=" + userId)
}

export const DisableUser = async (userId) => {
    return await ApiRequest('PUT', "admin/v2/disable-user?userId=" + userId)
}

export const UpdateChatGPTPrompt = async (promptId, data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => formData.append(key, data[key]));
    return await ApiRequest('PUT', `admin/v2/chatgpt-prompts/${promptId}`, formData);
}

export const UpdatePreferenceNegotiable = async (userId, preferenceField, value, isNegotiable) => {
    const payload = {
        preference_field: preferenceField,
        is_negotiable: isNegotiable
    };

    // Specific mapping for age range as requested: send min_age and max_age nested in value
    if (preferenceField === 'age' && typeof value === 'object' && value !== null && 'min' in value) {
        payload.value = {
            min_age: value.min,
            max_age: value.max
        };
    } else {
        payload.value = value;
    }

    return await ApiRequest('PUT', `admin/users/${userId}/preferences/negotiable`, payload);
}

export const PutUpdateEmployee = async (id, data) => {
    return await ApiRequest("PUT", `admin/employees/${id}`, data);
};

export const PutUpdateUnregisteredUser = async (userId, data) => {
    const token = localStorage.getItem('serviceToken');
    const response = await fetch(`https://api.v2.production.smartmatrimony.ai/admin/unregistered-users/${userId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data),
        mode: 'cors'
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
};


export const PutReactivatePair = async (userId, candidateId) => {
    return await ApiRequest('PUT', 'admin/reactivate-pair', {
        user_id: userId,
        candidate_id: candidateId
    });
};

export const PutUpdatePhotoStatus = async (userId, url, profile) => {
    return await ApiRequest('PUT', 'admin/v2/update-photo-status', {
        userId,
        url,
        profile,
    });
};

export const PutReactivateCreditPackage = async (packageId) => {
    return await ApiRequest('PATCH', `admin/credit-packages/${packageId}/activate`);
};